import classNames from 'classnames';
import type { CSSProperties } from 'react';

import { MarkdownRenderer } from './MarkdownRenderer';
import styles from './text-chart-content.module.css';

type VAlign = 'start' | 'center' | 'end';

interface TextChartContentProps {
  content: string | null;
  color?: string;
  vAlign?: VAlign;
  isGlobalAiChartPreview?: boolean;
}

export const TextChartContent = ({
  content,
  color,
  vAlign = 'start',
  isGlobalAiChartPreview = false,
}: TextChartContentProps) => (
  <div
    className={classNames(
      styles.textChart,
      isGlobalAiChartPreview ? styles.preview : styles.card
    )}
    data-valign={vAlign}
  >
    <div
      className={classNames(
        styles.body,
        isGlobalAiChartPreview ? styles.previewBody : styles.cardBody
      )}
      style={
        color ? ({ '--text-chart-color': color } as CSSProperties) : undefined
      }
    >
      <MarkdownRenderer
        content={content}
        variant={isGlobalAiChartPreview ? 'assistant' : 'default'}
      />
    </div>
  </div>
);
